import * as React from "react";
import { Game } from "../pages";

import styled from "styled-components";

const Wrapper = styled.div`
  padding: 10px;
`;

export default ({ game }: { game: Game }) => {
  const { name, isFinished, result } = game;

  if (!isFinished) {
    return <div>{name}</div>;
  }

  return (
    <Wrapper>
      <b>{name}</b>
      <ul>
        <li>🥇 3 poäng - {result[0]?.name}</li>
        <li>🥈 2 poäng - {result[1]?.name}</li>
        <li>🥉 1 poäng - {result[2]?.name}</li>
        <li>🚽 0 poäng - {result[3]?.name}</li>
        <li>🚽 0 poäng - {result[4]?.name}</li>
      </ul>
    </Wrapper>
  );
};
